import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import './Buttons.css';
import VoucherBTNnew from './VoucherBTNnew';

function ActionButtons({ item, handleSelectRow, page = 'Dashboard', bgcolor, theme }) {
  const memorizeRow = useMemo(() => item, [item]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const [visi, setVisi] = useState(true);
  const [activeRowId, setActiveRowId] = useState(null);

  // Get company registration type from Redux state
  const companyDetails = useSelector((state) => state?.companyReducer?.companyDetails);
  const companyRegistrationType = companyDetails?.relatedcompanydetailsnew?.[0]?.registrationtype;

  const dropdownRef = useRef(null);
  const popupRef = useRef(null);

  const handleSelection = useCallback((row, modal) => handleSelectRow(row, modal), [handleSelectRow]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isInsideDropdown = dropdownRef.current?.contains(event.target);
      const isInsidePopup = popupRef.current?.contains(event.target);
      const modalOpen = localStorage.getItem('modalOpen') === 'true'; 
      if (!isInsideDropdown && !isInsidePopup && !modalOpen) {
        setVisi(false);
        setMenuOpen(false);
        setActiveRowId(null);
      }
    };

    if (menuOpen) {
      const timeoutId = setTimeout(() => {
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);
      }, 50);

      return () => {
        clearTimeout(timeoutId);
        document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener('touchstart', handleClickOutside);
      };
    }
  }, [menuOpen]);

  const renderGLVButtons = () => (
    <>
      {memorizeRow?.category === 'group' &&
        memorizeRow.id !== 'p2' &&
        memorizeRow.id !== 'PG1' &&
        ['G', 'L'].map((label) => (
          <button
            key={label}
            className="letter-button enabled"
            style={{
              backgroundColor: label === 'G' ? theme.palette.primary.main : theme.palette.secondary.main,
              marginTop: isMobile ? '5px' : '0px',
              boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.5)',
            }}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              handleSelection({
                ...memorizeRow,
                action: 'create',
                modal: label === 'G' ? 'group' : 'ledger',
              });
              setMenuOpen(false);
              setActiveRowId(null);
            }}
            title={`New ${label === 'G' ? 'Group' : 'Ledger'}`}
          >
            <span className={label}>{label}</span>
          </button>
        ))}

      {page === 'Dashboard' &&
        memorizeRow?.id === 'PG1' &&
        ['G', 'L'].map((label) => (
          <button
            key={label}
            className="letter-button disabled"
            style={{
              marginTop: isMobile ? '5px' : '0px',
              display: isMobile ? 'none' : 'inline-block',
            }}
          >
            {label}
          </button>
        ))}

      {page === 'Dashboard' &&
        !['label', 'profitability'].includes(memorizeRow?.category) &&
        !(memorizeRow?.category === 'group' || memorizeRow?.id === 'p2') && (
          <VoucherBTNnew 
            key={memorizeRow?.id} 
            item={item} 
            theme={theme} 
            setVisi={setVisi}
            setMenuOpen={setMenuOpen}
            setActiveRowId={setActiveRowId}
            memorizeRow={memorizeRow}
          />
        )}
    </>
  );

  const deleteAndEditButton = () => (
    <>
      {(memorizeRow?.restrictedflag === 0 && memorizeRow?.id === 36
        ? [memorizeRow?.category === 'group' ? 'group' : 'ledger']
        : memorizeRow?.restrictedflag && memorizeRow?.id === 39
        ? [memorizeRow?.category === 'group' ? 'group' : 'ledger']
        : memorizeRow?.category === 'ledger' && (memorizeRow?.id === 'p2' || memorizeRow?.id === 25 || memorizeRow?.id === 23 || memorizeRow?.id === 24)
        ? []
        : memorizeRow?.category === 'ledger' && memorizeRow?.restrictedflag === 1 && companyRegistrationType === 1
        ? []
        : memorizeRow?.category === 'ledger' && memorizeRow?.restrictedflag === 1
        ? ['ledger']
        : memorizeRow?.category === 'ledger'
        ? ['deleteModal', 'ledger']
        : !memorizeRow?.restrictedflag && memorizeRow?.id !== 40
        ? ['deleteModal', memorizeRow?.category === 'group' ? 'group' : 'ledger']
        : []
      ).map((modal, index) => {
        const isEdit = modal !== 'deleteModal';
        const isDisabled = isEdit && memorizeRow?.is_active === 0;
        const color = modal === 'deleteModal' ? '#ffff' : '#ffff';

        return (
          <button
            key={index}
            style={{
              backgroundColor: isDisabled ? '#b0b0b0' : color,
              border: '1px solid gray',
              display: 'flex',
              flexDirection: 'column',
              borderRadius: '4px',
              height: '25px',
              width: '25px',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '5px',
            }}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              handleSelection({
                ...memorizeRow,
                action: modal === 'deleteModal' ? 'delete' : 'edit',
                modal,
              });
              setMenuOpen(false);
              setActiveRowId(null);
            }}
            disabled={isDisabled}
            title={`${modal === 'deleteModal' ? 'Delete' : 'Edit'} ${memorizeRow?.category}`}
          >
            {modal === 'deleteModal' ? (
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15">
                <path
                  d="M5.755 20.283 4 8h16l-1.755 12.283A2 2 0 0 1 16.265 22h-8.53a2 2 0 0 1-1.98-1.717zM21 4h-5V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v1H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2z"
                  fill="#ff0000"
                />
              </svg>
            ) : (
              '✏️'
            )}
          </button>
        );
      })}
    </>
  );

  const renderButtons = () => (
    <>
      {!isMobile &&
        (memorizeRow?.restrictedflag === 0 && memorizeRow?.id === 36
          ? [memorizeRow?.category === 'group' ? 'group' : 'ledger']
          : memorizeRow?.restrictedflag && memorizeRow?.id === 39
          ? [memorizeRow?.category === 'group' ? 'group' : 'ledger']
          : memorizeRow?.category === 'ledger' && (memorizeRow?.id === 'p2' || memorizeRow?.id === 25 || memorizeRow?.id === 23 || memorizeRow?.id === 24)
          ? []
          : memorizeRow?.category === 'ledger' && memorizeRow?.restrictedflag === 1 && companyRegistrationType === 1
          ? []
          : memorizeRow?.category === 'ledger' && memorizeRow?.restrictedflag === 1
          ? ['ledger']
          : memorizeRow?.category === 'ledger'
          ? ['deleteModal', 'ledger']
          : !memorizeRow?.restrictedflag && memorizeRow?.id !== 40
          ? ['deleteModal', memorizeRow?.category === 'group' ? 'group' : 'ledger']
          : []
        ).map((modal, index) => {
          const isEdit = modal !== 'deleteModal';
          const isDisabled = isEdit && memorizeRow?.is_active === 0;
          const color = modal === 'deleteModal' ? '#ffff' : '#ffff';

          return (
            <button
              key={index}
              className={`button-container ${isDisabled ? 'button-disabled' : 'button-enabled'}`}
              style={{ backgroundColor: isDisabled ? '#b0b0b0' : color }}
              onClick={() =>
                handleSelection({
                  ...memorizeRow,
                  action: modal === 'deleteModal' ? 'delete' : 'edit',
                  modal,
                })
              }
              disabled={isDisabled}
              title={`${modal === 'deleteModal' ? 'Delete' : 'Edit'} ${memorizeRow?.category}`}
            >
              {modal === 'deleteModal' ? (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path
                    d="M5.755 20.283 4 8h16l-1.755 12.283A2 2 0 0 1 16.265 22h-8.53a2 2 0 0 1-1.98-1.717zM21 4h-5V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v1H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2z"
                    fill="red"
                  />
                </svg>
              ) : (
                '✏️'
              )}
            </button>
          );
        })}
      {isMobile ? (
        <div className="dropdown-wrapper" ref={dropdownRef} style={{ position: 'relative', display: 'inline-block' }}>
          <button
            className="dropdown-button G L V"
            style={{
              backgroundColor: '#fff',
              borderRadius: '4px',
              padding: '6px 10px',
              border: 'none',
              cursor: 'pointer',
              height: '25px',
              width: '15px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: activeRowId === memorizeRow?.id ? '#ee5b2b' : 'black',
            }}
            onClick={(e) => {
              setVisi(true);
              setActiveRowId(memorizeRow?.id);
              const rect = e.target.getBoundingClientRect();
              setMenuPosition({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
              });
              setMenuOpen(true);
            }}
          >
            <span
              className="G L V"
              style={{
                transform: activeRowId === memorizeRow?.id ? 'scale(1.7)' : '',
              }}
            >
              ⋮
            </span>
          </button>
        </div>
      ) : (
        renderGLVButtons()
      )}
    </>
  );

  return (
    <>
      <div className="action-buttons">{renderButtons()}</div>

      {menuOpen &&
        createPortal(
          <div
            ref={popupRef}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onTouchStart={(e) => e.stopPropagation()}
            style={{
              position: 'absolute',
              top: `${menuPosition.top - 20}px`,
              left: `${menuPosition.left + 17}px`,
              backgroundColor: 'white',
              border: '1px solid #ccc',
              borderRadius: '8px',
              zIndex: 9999,
              padding: '8px',
              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
              visibility: visi ? 'visible' : 'hidden',
            }}
          >
            {renderGLVButtons()}
            {deleteAndEditButton()}
          </div>,
          document.body
        )}
    </>
  );
}

export default memo(ActionButtons);
